import '../App.css';
import subspaceLogo from '../images/subspace/subspace-logo-full.png';

function Subspace() {
  return (
    <div className="project-page">
      <div className="project-hero">
        <a href="https://subspace.network" target="_blank" rel="noopener noreferrer">
          <img className="project-hero-logo" src={subspaceLogo} alt="Subspace Network" />
        </a>
        <p className="project-hero-tagline">counterpoint are very proud to be participating in the Subspace Network</p>
      </div>

      <div className="project-content container">

        <div className="project-card">
          <h3 className="project-card-title">Achievements</h3>
          <ul className="project-list">
            <li>Q2 2022 Participated in the <a href="https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Ffarm-rpc.subspace.network#/accounts">Aries</a> stress test</li>
            <li>Q2/3 2022 Participated in the first phase of the <a href="https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Feu.gemini-1b.subspace.network%2Fws#/accounts">Gemini</a> incentivised testnet</li>
            <li>Testnet reward address (Substrate): <code>5DAvP1EJEhR8EE6NcJ1kEfkx9W9awjCRiEz64riJGD7SaE1c</code></li>
            <li>Testnet reward address (Subspace SS58): <code>st7NQTVwkwMsLyr4xUTfESrF1t7Y3tRggjWTpMQgb48SYQMeS</code></li>
            <li>Q3 2022 Invited to become an apprentice ambassador</li>
            <li>2022-09-20 Passed apprenticeship and became a full ambassador</li>
            <li>2022-09-27 Namechecked (twice!) in the <a href="https://medium.com/subspace-network/welcome-back-to-our-monthly-r-d-updates-subspace-network-683e239d625c">R&amp;D Update | September 2022</a> for <a href="https://github.com/counterpointsoftware/subspace-monitoring">community contributions</a> - a proud moment!</li>
          </ul>
        </div>

      </div>
    </div>
  );
}

export default Subspace;
